export default __webpack_public_path__ + "static/media/ledger.4878e558.png";